import { IFormInput } from "@shared/hooks";
import { ActivityName } from "../types";
import { ACTIVITY_MEASUREMENT_UNITS } from "./measurement";

const rules = [{ required: true, message: "errors.required" }];

export const MEASUREMENT_FORM_INPUTS: Record<Exclude<ActivityName, ActivityName.ECG | ActivityName.SPIROMETRY>, { inputs: IFormInput[]}> = {
    [ActivityName.WEIGHT]: {
        inputs: [
            {
                name: "weight",
                label: "vitalParameters.weight.title",
                returnKeyType: "done",
                keyboardType: "numeric",
                rules,
                unit: ACTIVITY_MEASUREMENT_UNITS[ActivityName.WEIGHT].weight
            }
        ]
    },
    [ActivityName.TEMPERATURE]: {
        inputs: [
            {
                name: "temperature",
                label: "vitalParameters.temperature.title",
                returnKeyType: "done",
                keyboardType: "numeric",
                rules,
                unit: ACTIVITY_MEASUREMENT_UNITS[ActivityName.TEMPERATURE].temperature
            }
        ]
    },
    [ActivityName.BLOOD_PRESSURE]: {
        inputs: [
            {
                name: "systolic",
                label: "vitalParameters.blood_pressure.variants.systolic",
                returnKeyType: "done",
                keyboardType: "numeric",
                rules,
                unit: ACTIVITY_MEASUREMENT_UNITS[ActivityName.BLOOD_PRESSURE].systolic
            },
            {
                name: "diastolic",
                label: "vitalParameters.blood_pressure.variants.diastolic",
                returnKeyType: "done",
                keyboardType: "numeric",
                rules,
                unit: ACTIVITY_MEASUREMENT_UNITS[ActivityName.BLOOD_PRESSURE].diastolic
            }
        ]
    },
    [ActivityName.HEART_RATE]: {
        inputs: [
            {
                name: "heartRate",
                label: "vitalParameters.heart_rate.title",
                returnKeyType: "done",
                keyboardType: "numeric",
                rules,
                unit: ACTIVITY_MEASUREMENT_UNITS[ActivityName.HEART_RATE].heartRate
            }
        ]
    },
    [ActivityName.SPO2]: {
        inputs: [
            {
                name: "saturation",
                label: "vitalParameters.spo2.title",
                returnKeyType: "done",
                keyboardType: "numeric",
                rules,
                unit: ACTIVITY_MEASUREMENT_UNITS[ActivityName.SPO2].spo2
            }
        ]
    },
    [ActivityName.STEP]: {
        inputs: [
            {
                name: "steps",
                label: "common.vitalParameters.names.step",
                returnKeyType: "done",
                keyboardType: "numeric",
                rules,
                unit: ACTIVITY_MEASUREMENT_UNITS[ActivityName.STEP].step
            }
        ]
    },
    [ActivityName.DYSPNEA]: {
        inputs: [
            {
                name: "dyspnea",
                label: "common.vitalParameters.names.dyspnea",
                returnKeyType: "done",
                keyboardType: "numeric",
                rules,
                unit: ACTIVITY_MEASUREMENT_UNITS[ActivityName.DYSPNEA].dyspnea
            }
        ]
    }
};
